export enum ResourceStatuses {
  SUBMIT = 'submit',
  IN_REVIEW = 'in_review',
  ACCEPT = 'accept',
  REJECT = 'reject',
  PUBLISH = 'publish',
  UNPUBLISH = 'unpublish',
}
